module.exports = __webpack_public_path__ + "static/media/Power_Supply.b535d6c8.svg";